export default __webpack_public_path__ + "static/media/favicon.74dc38b0.ico";